import ParticipantInformation from '../../../../components/common/ParticipantInformation';
import PortalLayout from '../../../../layouts/PortalLayout';

function PISScene() {
  return (
    <PortalLayout>
      <ParticipantInformation />
    </PortalLayout>
  );
}

export default PISScene;
